/* tslint:disable */

import { ReaderInlineDataFragment } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useMeasurementUnit_user = {
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $refType": "useMeasurementUnit_user";
};
export type useMeasurementUnit_user$data = useMeasurementUnit_user;
export type useMeasurementUnit_user$key = {
    readonly " $data"?: useMeasurementUnit_user$data;
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useMeasurementUnit_user"
};
(node as any).hash = '9961980a672ba9895d0962d02341a102';
export default node;
